import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";
import Select from "react-select";
import OrdersServices from "./OrdenesServicios";

const Remisiones = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [error, setError] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cardCode, setCardCode] = useState("");
    const [serviceType, setServiceType] = useState("");
    const [complementario, setComplementario] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [groupingType, setGroupingType] = useState("SN_CodEscuela"); // Opción de agrupación seleccionada
    const [useDiApi, setUseDiApi] = useState(false);
    const [projects, setProjects] = useState([]);
    const [servicesType, setServicesType] = useState("");
    const [message, setMessage] = useState("");
    
    
    
    const fetchItems = async () => {
        try {
            const responsePro = await apiClient.get("/sales-orders/projects");
            
            // Valores estáticos
            const staticItems = [
                { value: "DES", label: "Desayuno" },
                { value: "ALM", label: "Almuerzo" },
                { value: "MER", label: "Merienda" },
                { value: "CEN", label: "Cena" },
                { value: "LIM", label: "LIMPIEZA" },
                { value: "UTE", label: "UTENSILIOS" },
                { value: "EQU", label: "EQUIPAMIENTOS" },
            ];
            setServicesType(staticItems);

            if (!Array.isArray(responsePro.data)) {
                throw new Error("Los datos recibidos no son un array");
            }
            // Formatear los Proyectos para el select
            const formattedProjects = responsePro.data.map((item) => ({
                value: item.PrjCode,
                label: `${item.PrjName}`,
            }));
            setProjects(formattedProjects);

        } catch (err) {
            console.error("Error obteniendo datos", err);
            setError("Error al obtener los datos.");
        }
    };

    // Función para obtener datos desde el backend
    const fetchOrders = async () => {
        try {
            // console.log(startDate, endDate, cardCode, serviceType)
            const sapUser = JSON.parse(localStorage.getItem("sapUser"));
            const Company = sapUser?.CompanyDB || "";
            const response = await apiClient.get("/sales-orders/grouped", {
                params: { startDate, endDate, cardCode: cardCode?.value || "", serviceType, complementario, company: Company }
            });

            //console.log("Datos recibidos:", response.data);

            if (!Array.isArray(response.data)) {
                throw new Error("Los datos recibidos no son un array");
            }

            // Aplicar agrupación según la opción seleccionada
            const groupedData = response.data.reduce((acc, order) => {
                let key;
                
                if (groupingType === "SN_CodEscuela") {
                    key = `${order.CodSN}-${order.CodEscuela}`;
                } else if (groupingType === "SN_CodEscuela_FecElab") {
                    key = `${order.CodSN}-${order.CodEscuela}-${order.FecElab}`;
                }

                if (!acc[key]) {
                    acc[key] = {
                        CodSN: order.CodSN,
                        SN: order.SN,
                        CodEscuela: order.CodEscuela,
                        Institucion: order.Institucion,
                        Localidad: order.Localidad,
                        Lote: order.Lote,
                        NroOS: order.NroOS,
                        FecElab: groupingType === "SN_CodEscuela_FecElab" ? order.FecElab : null,
                        Orders: [],
                    };
                }
                acc[key].Orders.push(order);
                return acc;
            }, {});

            const formattedData = Object.values(groupedData);
            setOrders(formattedData);
            setFilteredOrders(formattedData);
        } catch (err) {
            console.error("Error fetching orders", err);
            setError("Error al obtener órdenes de ventas.");
        }
    };
    
    // 🔍 Filtrado dinámico
    useEffect(() => {
        fetchItems();
        if (!searchTerm) {
            setFilteredOrders(orders);
            return;
        }

        const filteredData = orders.filter((order) =>
            (order.SN ? order.SN.toLowerCase() : "").includes(searchTerm.toLowerCase()) || 
            (order.Institucion ? order.Institucion.toLowerCase() : "").includes(searchTerm.toLowerCase()) || 
            (order.CodSN ? order.CodSN.toString().toLowerCase() : "").includes(searchTerm.toLowerCase()) || 
            (order.CodEscuela ? order.CodEscuela.toString().toLowerCase() : "").includes(searchTerm.toLowerCase()) 
        );

        setFilteredOrders(filteredData);
    }, [searchTerm, orders]);

    // Componente expandible para mostrar líneas de orden
    const ExpandedComponent = ({ data }) => (
        <div className="p-2">
            <h6 style={{ fontSize: "12px" }}>Detalles de la Orden</h6>
            <table className="table table-sm table-bordered" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>ItemCode</th>
                        <th>Descripción</th>
                        <th>Cantidad</th>
                        <th>Precio</th>
                        <th>Acuerdo Global</th>
                        <th>Fecha Elaboración</th>
                        <th>Proyecto</th>
                        <th>Plato</th>
                        <th>Ensalada</th>
                        <th>Postre</th>
                    </tr>
                </thead>
                <tbody>
                    {data.Orders.map((order, index) => (
                        <tr key={index}>
                            <td>{order.CodServicio}</td>
                            <td>{order.Servicio}</td>
                            <td>{order.CantRaciones}</td>
                            <td>{order.Precio}</td>
                            <td>{order.AcuerdoGlobal}</td>
                            <td>{order.FecElab}</td>
                            <td>{order.Proyecto}</td>
                            <td>{order.Plato}</td>
                            <td>{order.Ensalada}</td>
                            <td>{order.Postre}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    const columns = [
        {
            name: "Código SN",
            selector: (row) => row.CodSN,
            sortable: true,
            width: "150px",
        },
        {
            name: "Nro. OS",
            selector: (row) => row.NroOS,
            sortable: true,
            width: "130px",
        },
        {
            name: "Lote",
            selector: (row) => row.Lote,
            sortable: true,
            width: "130px",
        },
        {
            name: "Localidad",
            selector: (row) => row.Localidad,
            sortable: true,
            width: "130px",
        },
        {
            name: "Código Escuela",
            selector: (row) => row.CodEscuela,
            sortable: true,
            width: "150px",
        },
        {
            name: "Institución",
            selector: (row) => row.Institucion,
            sortable: true,
            width: "400px",
        },
    ];

    // Agregar columna de fecha de elaboración solo si la agrupación incluye esta fecha
    if (groupingType === "SN_CodEscuela_FecElab") {
        columns.push({
            name: "Fecha Elaboración",
            selector: (row) => row.FecElab,
            sortable: true,
            width: "150px",
        });
    }

    // 📌 Función para generar JSON con la estructura correcta
    const generateJSON = () => {
        const today = new Date();
        const limiteFecha = new Date(today);
        limiteFecha.setDate(today.getDate() - 28); // hoy - 28 días

        const payload = filteredOrders.map(order => {
            let docDateISO = endDate || today.toISOString().split('T')[0];
            let inicioTras = startDate || "";
            let finTras = endDate || "";

            if (groupingType === "SN_CodEscuela_FecElab") {
                const fecElabOriginal = new Date(order.Orders[0].FecElab);
                const fecElabISO = fecElabOriginal.toISOString().split('T')[0];

                // U_InicioTras y U_FinTras siempre usan FecElab original
                inicioTras = fecElabISO;
                finTras = fecElabISO;

                // DocDate se ajusta si la fecha es muy antigua
                const fecValidada = fecElabOriginal >= limiteFecha ? fecElabOriginal : limiteFecha;
                docDateISO = fecValidada.toISOString().split('T')[0];
            }

            return {
                "CardCode": order.CodSN,
                "ContactPersonCode": order.CodEscuela,
                "DocDate": docDateISO,
                "U_InicioTras": inicioTras,
                "U_FinTras": finTras,
                "U_distrito": order.Localidad,
                "U_Lote": order.Lote,
                "U_NroOS": order.NroOS,
                "U_Serv": serviceType,
                "DocumentLines": order.Orders.map(line => ({
                    "ItemCode": line.CodServicio,
                    "Quantity": line.CantRaciones,
                    "PriceAfterVAT": line.Precio,
                    "ItemDescription": line.Servicio,
                    "ProjectCode": line.Proyecto,
                    "AgreementNo": line.AcuerdoGlobal,
                    "U_FechaElab": line.FecElab,
                    "U_PlatoPrincipal": line.Plato,
                    "U_Ensalada": line.Ensalada,
                    "U_Postre": line.Postre
                }))
            };
        });

        return payload;
    };




    // 📌 Enviar JSON al backend
    const sendDataToBackend = async () => {
        const payload = generateJSON();
        console.log(payload);
        try {
            const endpoint = useDiApi ? "/crear-remision-diapi" : "/crear-remision";
            const response = await apiClient.post(endpoint, { orders: payload }, { timeout: 600000 });
            
            // Procesar la respuesta
                const results = response.data || [];
                const successCount = results.filter(r => r.status === "success").length;
                const warningCount = results.filter(r => r.status === "warning").length;
                const errorCount = results.filter(r => r.status === "error").length;

                let messageText = "";
                if (successCount > 0) {
                    messageText += `${successCount} Remisiones creadas con éxito.\n`;
                }
                if (warningCount > 0) {
                    messageText += `${warningCount} Remisiones sin cambios.\n`;
                }
                if (errorCount > 0) {
                    messageText += `${errorCount} errores en la creación.\n`;
                }

                setMessage(messageText);
                if (messageText) alert(messageText);
                setCardCode("");
                setComplementario("");
                setStartDate("");
                setEndDate("");
                setServiceType("");
                setGroupingType("");
                setError("");
        } catch (error) {
            console.error("Error al enviar los datos", error);
            alert("Error al enviar la solicitud.");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Remisiones por Socio de Negocio</h2>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="row">
                <div className="col-md-3">
                    <label>Fecha Inicial:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Final:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Código de Proyecto:</label>
                    <Select
                        options={projects}
                        value={cardCode}
                        onChange={setCardCode}
                        placeholder="Seleccione un proyecto..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-3">
                    <label>Tipo de Servicio:</label>
                    <select className="form-control" value={serviceType} onChange={(e) => setServiceType(e.target.value)}>
                        <option value="">Seleccione</option>
                        <option value="ALM">Almuerzo</option>
                        <option value="CEN">Cena</option>
                        <option value="MER">Merienda</option>
                        <option value="DES">Desayuno</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <label>Orden de Servicio:</label>
                    <select className="form-control" value={complementario} onChange={(e) => setComplementario(e.target.value)}>
                        <option value="">Seleccione</option>
                        <option value="N">Normal</option>
                        <option value="C">Complementario</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <label>Tipo de Agrupación:</label>
                    <select className="form-control" value={groupingType} onChange={(e) => setGroupingType(e.target.value)}>
                        <option value="SN_CodEscuela">Por SN y CodEscuela</option>
                        <option value="SN_CodEscuela_FecElab">Por SN, CodEscuela y FecElab</option>
                    </select>
                </div>
            </div>

            <button className="btn btn-success mt-2" onClick={fetchOrders}>Buscar</button>
            <button className="btn btn-primary mt-2 ml-2" onClick={sendDataToBackend}>Registrar en SAP</button>
            <div className="form-check form-check-inline mt-2 ml-3">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="useDiApi"
                    checked={useDiApi}
                    onChange={(e) => setUseDiApi(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="useDiApi">
                    DI API
                </label>
            </div>
            <DataTable
                columns={columns}
                data={filteredOrders}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                pagination
            />
        </div>
    );
};

export default Remisiones;
